export default {
  addCard: {
    title: "إضافة بطاقة بنكية جديدة",
    warning: "يرجى ملاحظة، يجب أن تكون البطاقة التي تسجلها باسمك.",
    inputLabel: "رقم البطاقة",
    button: "تحقق وأضف البطاقة",
    verifyButton: "تم التحقق",
    invalidCardNumber: "رقم البطاقة المدخل غير صالح."
  },
  notRegisteredCard: {
    title: "لم يتم التحقق",
    button: "طلب تسجيل البطاقة مرة أخرى"
  },
  notRegisteredShebaCard: {
    title: "لم يتم التحقق",
    button: "طلب تسجيل شبا مرة أخرى"
  },
  offlinePaymentNoticeCard: {
    title:
      "يرجى ملاحظة، معرف الإيداع هو رقم الهوية الوطنية. تأكد من كتابة معرف الإيداع على إيصال البنك عند إجراء إيداع غير متصل.",
    hideCheckbox: "عدم عرض هذه الرسالة مرة أخرى",
    button: "فهمت"
  },
  userRegisteredCard: {
    title: "لم تسجل أي بطاقات بنكية",
    description:
      "لإيداع الريال، سجل بطاقتك البنكية أولاً. يرجى ملاحظة، لإيداعات الريال، استخدم فقط البطاقات البنكية المسجلة. خلاف ذلك، سيتم تعليق معاملتك.",
    button: "إضافة بطاقة بنكية"
  },
  notAvailableCard: {
    title: "لم تسجل أي بطاقات بنكية",
    description:
      "لإيداع الريال، سجل بطاقتك البنكية أولاً. يرجى ملاحظة، لإيداعات الريال، استخدم فقط البطاقات البنكية المسجلة. خلاف ذلك، سيتم تعليق معاملتك.",
    button: "إضافة بطاقة بنكية"
  },
  depositConfirmationCard: {
    desPartOne: "يرجى ملاحظة، لإيداعات الريال ",
    desPartTwo: "استخدم فقط البطاقات البنكية المسجلة ",
    desPartThree: "خلاف ذلك، سيتم تعليق معاملتك.",
    continueButton: "فهمت، المتابعة إلى بوابة الدفع",
    registeredCard: "بطاقاتك المسجلة",
    addCard: "إضافة بطاقة جديدة"
  },
  accountList: {
    title: "أرقام حسابات وبطاقات Excoino"
  },
  suggestionApps: {
    goToPWA: "الانتقال إلى إصدار الويب",
    installGuide:
      "لإضافة تطبيق Excoino الويب إلى الشاشة الرئيسية لهاتفك المحمول، اتبع الخطوات التالية:",
    shareTitle: "اضغط على زر {n} في الشريط السفلي",
    addToHomeTitle: "في القائمة المفتوحة، في الأسفل، اختر {n}.",
    addTitle: "في الخطوة التالية، اضغط على {n} في الأعلى",
    confirmButton: "فهمت"
  },
  expiredOrderCard: {
    title: "انتهاء مهلة إكمال الطلب",
    subtitle: "انتهى وقت إكمال هذا الطلب",
    repeatOrderButton: "كرر هذا الطلب",
    goToWalletButton: "العودة إلى صفحة المحفظة"
  },
  cancelOrderCard: {
    title: "إلغاء الطلب",
    subtitle: "هل أنت متأكد من أنك تريد إلغاء طلبك؟",
    cancelOrderButton: "نعم، ألغيه",
    goBackButton: "إلغاء الإلغاء"
  }
};
